import type { AgentTool } from '@saaga/shared/interfaces/agent-tool.interface'
import type { ReactNode } from 'react'

import { ToolListItem } from './tool-list-item.atom'

export interface ToolListManagerProps {
  selectedToolList: AgentTool[]
  onRemove: (toolId: string) => void
  isDisabled?: boolean
  emptyMessage?: string
}

/**
 * Displays a vertical list of selected tools with name, description and remove button.
 * Shows empty state message when no tools are selected.
 */
export const ToolListManager = ({
  selectedToolList,
  onRemove,
  isDisabled = false,
  emptyMessage = 'No tools selected',
}: ToolListManagerProps): ReactNode => {
  if (selectedToolList.length === 0) {
    return <p className="tool-list-manager-empty text-sm text-muted-foreground">{emptyMessage}</p>
  }

  return (
    <div className="tool-list-manager flex flex-col gap-2">
      {selectedToolList.map((tool) => (
        <ToolListItem key={tool.id} tool={tool} onRemove={onRemove} isDisabled={isDisabled} />
      ))}
    </div>
  )
}

ToolListManager.displayName = 'ToolListManager'
